/**
 * Where the DMW server's HTTP API is. Set `VITE_DMW_API_BASE_URL` at build time (see
 * `.env.example`). The default `/api` is the path the Vite dev server forwards to the server.
 */
const DEFAULT_API_BASE_URL = "/api";

export const API_BASE_URL: string = withoutTrailingSlash(
  import.meta.env.VITE_DMW_API_BASE_URL ?? DEFAULT_API_BASE_URL,
);

/** The URL of an API path such as `/health/ready`. */
export function apiUrl(path: `/${string}`): string {
  return `${API_BASE_URL}${path}`;
}

/** The `ws:` or `wss:` URL of a WebSocket path of the API, such as `/threads/live`. */
export function apiWebSocketUrl(path: `/${string}`, pageUrl: string): string {
  const url = new URL(apiUrl(path), pageUrl);
  url.protocol = url.protocol === "https:" ? "wss:" : "ws:";
  return url.toString();
}

function withoutTrailingSlash(baseUrl: string): string {
  const trimmed = baseUrl.trim();
  return trimmed.endsWith("/") ? trimmed.slice(0, -1) : trimmed;
}

/** Resolver routes sit beside /api on the configured server (ADR-0012). */
export function resolverUrl(path: `/${string}`): string {
  return `${API_BASE_URL.replace(/\/api$/, "")}${path}`;
}
